import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Image from '../components/Image';
import Hotspot from './Hotspot';

const styles = theme => ({
    root: {
        position: 'relative'
    },
    image: {
        boxShadow: '24px 24px 36px 0 rgba(0,0,0,0.2), 48px 48px 0 0 rgba(227,98,98,0.15)',
        [theme.breakpoints.down('xs')]: {
            boxShadow: 'none'
        },
    }
});
  
class HotspotImage extends React.Component {
    render() {
        const { classes, filename, hotspots, style, show, imageStyles, callback } = this.props;
        return (
            <div className={classes.root} style={{...style, height: show ? undefined : 0 }}>
                <Image src={filename} width='100%' className={classes.image} style={imageStyles}/>
                {hotspots.map((hotspot, i) => <Hotspot key={i} {...hotspot} callback={callback}/>)}
            </div>
        );
    }
}

HotspotImage.propTypes = {
    classes: PropTypes.object.isRequired,
    filename: PropTypes.string.isRequired,
};

export default withStyles(styles)(HotspotImage);